const PRINT_MODAL_OPTIONS = {
  QUIZ: {
    queryParam: "quiz",
    label: "Quiz",
  },
  QUIZ_ANSWERS: {
    queryParam: "quiz_answers",
    label: "Quiz Answers",
  },
  WRITE_PROMPT: {
    queryParam: "write_prompt",
    label: "Write Prompt",
  },
  POWER_WORDS: {
    queryParam: "power_words",
    label: "Power Words",
  },
  POWER_WORDS_ANSWERS: {
    queryParam: "power_words_answers",
    label: "Power Words Answers",
  },
  ECO_MODE: {
    queryParam: "eco_mode",
    label: "Ink-Saving Mode",
  },
};

// Currently only supporting Print Modal (with options) for premium teachers
// Set option list based on which activities the content has
const getPrintModalOptions = (
  contentHasPrintableQuiz: boolean,
  contentHasWritePrompt: boolean,
  contentHasPowerWords: boolean,
) => {
  const printOptions = [];

  if (contentHasPrintableQuiz) {
    printOptions.push(
      PRINT_MODAL_OPTIONS.QUIZ,
      PRINT_MODAL_OPTIONS.QUIZ_ANSWERS,
    );
  }

  if (contentHasWritePrompt) {
    printOptions.push(PRINT_MODAL_OPTIONS.WRITE_PROMPT);
  }

  if (contentHasPowerWords) {
    printOptions.push(
      PRINT_MODAL_OPTIONS.POWER_WORDS,
      PRINT_MODAL_OPTIONS.POWER_WORDS_ANSWERS,
    );
  }

  printOptions.push(PRINT_MODAL_OPTIONS.ECO_MODE);
  return printOptions;
};

const getContentQueryParamFromSelectedOptions = (
  selectedPrintOptions: string[],
) => {
  // The original print content query parameter (excludes power words and eco mode) was
  // set based on the combo of options chosen (i.e. article_write_prompt_and_quiz)

  // These new print options are added to the url as individual query params (handled in PrintModal)
  const queryParamsToExclude = [
    PRINT_MODAL_OPTIONS.POWER_WORDS.queryParam,
    PRINT_MODAL_OPTIONS.POWER_WORDS_ANSWERS.queryParam,
    PRINT_MODAL_OPTIONS.ECO_MODE.queryParam,
  ];

  // Filter out new options that will be treated as query params
  const filteredPrintOptions = selectedPrintOptions.filter((o) => {
    return !queryParamsToExclude.includes(o);
  });
  // Sort options and convert to string
  const selectedOptionsString = filteredPrintOptions.sort().toString();
  switch (selectedOptionsString) {
    case "quiz":
      return "article_and_quiz";
    case "quiz_answers":
    case "quiz,quiz_answers":
      return "article_quiz_and_answers";
    case "write_prompt":
      return "article_and_write_prompt";
    case "quiz,write_prompt":
      return "article_write_prompt_and_quiz";
    case "quiz,quiz_answers,write_prompt":
    case "quiz_answers,write_prompt":
      return "article_write_prompt_quiz_and_answers";
    default:
      return "article_only";
  }
};

export {
  PRINT_MODAL_OPTIONS,
  getPrintModalOptions,
  getContentQueryParamFromSelectedOptions,
};
